import {captureException} from '@sentry/browser';
import i18n from 'i18next';
import {showNotification} from 'platform/components';

import {isNotNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {RowData} from '../types/RowData';

export const getColumnData =
  (row: RowData, gridCode: string) =>
  <T = unknown, S = unknown>(column: string, options?: {isOptional?: boolean}) => {
    const columnData = isArray(row) ? row?.[0]?.[column] : row?.[column];

    // success response
    if (isNotNil(columnData)) {
      return columnData as {value: T; style: S; id: string};
    }

    if (options?.isOptional) {
      return null;
    }

    // production error handling
    showNotification.error(
      i18n.t('page.datagrid.notifications.columnDataIsNull', {columnKey: column}),
      {autoClose: false}
    );

    if (process.env.ENV_TYPE === 'prod') {
      captureException(
        new Error(`${gridCode} Column data for ${column} column is null or undefined`)
      );
    }

    return null;
  };
